import {BaseEntity} from "../../common/baseEntity";
import {LocationType} from "./locationType";
/**
 * Created by alex.y on 7/31/2017.
 */
export class Location extends BaseEntity<number> {
    public Country: string = "";
    public City: string = "";
    public Street: string = "";
    public Zip: string = "";
    public Type?: LocationType;
    public State: string = "";

    public constructor(obj?: Partial<Location>) {
        super();
        Object.assign(this, obj);
    }
}



// WEBPACK FOOTER //
// ./app/objects/management/locationManagement/location.ts